export const initSlider = () => {
	const sliders = document.querySelectorAll( 'section.slider-component' );

	if ( !sliders.length )
	{
		return;
	}

	const calculateStep = ( element : HTMLElement ) => {
		const elementStyle = window.getComputedStyle( element );
		const elementWidth = element.offsetWidth;
		const elementMargin = elementStyle.marginRight ? parseFloat( elementStyle.marginRight ) : 0;

		return elementWidth + elementMargin;
	};

	Array.from( sliders ).forEach( ( it ) => {
		const slides = it.querySelector( 'ul.slides' ) as HTMLElement;
		const bookmarks = it.querySelector( 'ul.bookmarks' );
		const buttons = it.querySelector( 'ul.buttons' );
		let currentIndex = 0;
		let currentPosition = 0;

		if ( !slides || !bookmarks || !buttons )
		{
			return;
		}

		const counter = buttons.querySelector( 'li.counter' );

		if ( !counter )
		{
			return;
		}

		let currentSlide = slides.children[currentIndex] as HTMLElement;
		let currentDescription = bookmarks.children[currentIndex] as HTMLElement;

		buttons.addEventListener( 'click', ( evt ) => {
			const currentButton = evt.target as HTMLElement;

			if ( !currentButton || !currentButton.classList.contains( 'prev' ) && !currentButton.classList.contains( 'next' ) )
			{
				return;
			}

			const direction = currentButton.classList.contains( 'prev' ) ? -1 : 1;
			const step = calculateStep( currentSlide );
			
			currentIndex += direction;
			currentPosition += step * direction * -1;

			if ( currentIndex < 0 )
			{
				currentIndex = slides.children.length - 1;
				currentPosition = step * ( slides.children.length - 1 ) * -1;

			}
			else if ( currentIndex >= slides.children.length )
			{
				currentIndex = 0;
				currentPosition = 0;
			}

			currentSlide.classList.remove( 'current' );
			currentDescription.classList.remove( 'current' );
			currentSlide = slides.children[currentIndex] as HTMLElement;
			currentDescription = bookmarks.children[currentIndex] as HTMLElement;
			currentSlide.classList.add( 'current' );
			currentDescription.classList.add( 'current' );
			counter.innerHTML = `${currentIndex + 1}/${slides.children.length}`;
			slides.style.transform = `translateX( ${currentPosition}px )`;
		} );
	} );
};


// WEBPACK FOOTER //
// ./app/Routes/Index/Slider/index.ts